// extracted by mini-css-extract-plugin
module.exports = {"root":"FormLabel_root__CqYds","label":"FormLabel_label__3tSmo","error":"FormLabel_error__NpHDJ"};